var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useGetModuleBuilderExportCustomQuery, useSaveModuleBuilderExportCustomMutation, } from "@/store/api";
import { LoaderImage } from "@/utils/loader";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ETCRM_URL } from "@/utils/const";
export default function ExportCustom() {
    var _this = this;
    var t = useTranslation(["common", "ModuleBuilder"]).t;
    var moduleList = useGetModuleBuilderExportCustomQuery(false).data;
    var exportMutation = useSaveModuleBuilderExportCustomMutation()[0];
    var _a = useState([]), modules = _a[0], setModules = _a[1];
    var _b = useState(""), name = _b[0], setName = _b[1];
    var _c = useState(""), author = _c[0], setAuthor = _c[1];
    var _d = useState(""), desc = _d[0], setDesc = _d[1];
    var _e = useState([]), selectedModules = _e[0], setSelectedModules = _e[1];
    var _f = useState(false), isLoad = _f[0], setIsLoading = _f[1];
    useEffect(function () {
        (moduleList === null || moduleList === void 0 ? void 0 : moduleList.data) && setModules(moduleList === null || moduleList === void 0 ? void 0 : moduleList.data);
    }, [moduleList]);
    var isExportDisabled = name.trim().length === 0 || selectedModules.length === 0;
    var toggleSelectedModule = function (moduleName, isChecked) {
        setSelectedModules(function (prev) {
            if (isChecked) {
                return prev.includes(moduleName) ? prev : __spreadArray(__spreadArray([], prev, true), [moduleName], false);
            }
            return prev.filter(function (m) { return m !== moduleName; });
        });
    };
    var downloadFile = function (fileData, fileName) { return __awaiter(_this, void 0, void 0, function () {
        var fullUrl, link;
        return __generator(this, function (_a) {
            fullUrl = "".concat(ETCRM_URL, "/").concat(fileData);
            link = document.createElement("a");
            link.href = fullUrl;
            link.download = fileName || "export.zip";
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            // Nettoyer après un court délai
            setTimeout(function () {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(fullUrl);
            }, 100);
            return [2 /*return*/];
        });
    }); };
    var exportCustomizations = function () { return __awaiter(_this, void 0, void 0, function () {
        var result, fileData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, exportMutation({
                            body: {
                                name: name,
                                author: author,
                                description: desc,
                                modules: selectedModules,
                            },
                        })];
                case 2:
                    result = _a.sent();
                    fileData = (result === null || result === void 0 ? void 0 : result.data) || "";
                    if (!(fileData === null || fileData === void 0 ? void 0 : fileData.data)) return [3 /*break*/, 4];
                    return [4 /*yield*/, downloadFile(fileData === null || fileData === void 0 ? void 0 : fileData.data, "".concat(name || "export", ".zip"))];
                case 3:
                    _a.sent();
                    resetForm();
                    return [3 /*break*/, 5];
                case 4:
                    console.error("Aucune donnée de fichier reçue");
                    _a.label = 5;
                case 5:
                    setIsLoading(false);
                    return [3 /*break*/, 7];
                case 6:
                    error_1 = _a.sent();
                    setIsLoading(false);
                    console.log(error_1);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var resetForm = function () {
        console.log("reset here");
        setName("");
        setAuthor("");
        setDesc("");
        setSelectedModules([]);
    };
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "max-w-5xl mt-4" }, { children: _jsxs("div", __assign({ className: "space-y-4 relative" }, { children: [isLoad && _jsx(LoaderImage, {}), _jsx("button", __assign({ className: "button primary disabled:opacity-50 disabled:cursor-not-allowed", disabled: isExportDisabled, onClick: function () { return exportCustomizations(); } }, { children: t("LBL_EC_EXPORTBTN", { ns: "ModuleBuilder" }) })), _jsxs("div", __assign({ className: "flex flex-col md:flex-row md:items-center gap-2 md:gap-4" }, { children: [_jsx("label", __assign({ className: "w-full md:w-36 text-left font-medium text-gray-700 flex-shrink-0" }, { children: t("LBL_EC_NAME", { ns: "ModuleBuilder" }) })), _jsx("input", { type: "text", required: true, value: name, onChange: function (e) { return setName(e.target.value); }, className: "flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" })] })), _jsxs("div", __assign({ className: "flex flex-col md:flex-row md:items-center gap-2 md:gap-4" }, { children: [_jsx("label", __assign({ className: "w-full md:w-36 text-left font-medium text-gray-700 flex-shrink-0" }, { children: t("LBL_EC_AUTHOR", { ns: "ModuleBuilder" }) })), _jsx("input", { type: "text", onChange: function (e) { return setAuthor(e.target.value); }, className: "flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" })] })), _jsxs("div", __assign({ className: "flex flex-col md:flex-row md:items-start gap-2 md:gap-4" }, { children: [_jsx("label", __assign({ className: "w-full md:w-36 text-left font-medium text-gray-700 flex-shrink-0 md:pt-2" }, { children: t("LBL_EC_DESCRIPTION", { ns: "ModuleBuilder" }) })), _jsx("textarea", { className: "flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500", onChange: function (e) { return setDesc(e.target.value); } })] })), _jsx("div", { children: _jsx("ul", __assign({ className: "flex flex-row justify-between" }, { children: modules &&
                                Object.keys(modules).map(function (item) { return (_jsxs("li", { children: [_jsx("input", { type: "checkbox", className: "mr-2", checked: selectedModules.includes(item), onChange: function (e) {
                                                return toggleSelectedModule(item, e.target.checked);
                                            } }), item] }, item)); }) })) })] })) })) }));
}
